import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getOffers } from "../../../../services/dashboard/apiOffers";

export function useOffers({
  filter,
  searchValue,
  include,
  includeFields,
  sortBy,
  perPage,
  page = 1,
  filterAndSortAndPageQuery,
} = {}) {
  const queryClient = useQueryClient();

  const {
    isPending,
    data: offers,
    isSuccess,
  } = useQuery({
    queryKey: [
      "offers",
      page,
      perPage,
      filter,
      searchValue,
      include,
      includeFields,
      sortBy,
      filterAndSortAndPageQuery,
    ],
    queryFn: () =>
      getOffers({
        page,
        perPage,
        filter,
        searchValue,
        include,
        includeFields,
        sortBy,
        filterAndSortAndPageQuery,
      }),
  });
  const totalPages = Math.ceil(offers?.meta?.total / offers?.meta?.per_page);
  // PRE-FETCHING
  if (isSuccess && page < totalPages) {
    queryClient.prefetchQuery({
      queryKey: [
        "offers",
        page,
        perPage,
        filter,
        searchValue,
        include,
        includeFields,
        sortBy,
        filterAndSortAndPageQuery,
      ],
      queryFn: () =>
        getOffers({
          page,
          perPage,
          filter,
          searchValue,
          include,
          includeFields,
          sortBy,
          filterAndSortAndPageQuery,
        }),
    });
  }

  if (isSuccess && page > 1) {
    queryClient.prefetchQuery({
      queryKey: [
        "offers",
        page,
        perPage,
        filter,
        searchValue,
        include,
        includeFields,
        sortBy,
        filterAndSortAndPageQuery,
      ],
      queryFn: () =>
        getOffers({
          page,
          perPage,
          filter,
          searchValue,
          include,
          includeFields,
          sortBy,
          filterAndSortAndPageQuery,
        }),
    });
  }

  return { isPending, offers };
}
